<template>
  <div class="page page-service-work">
    <h3>Изменение работы техобслуживания</h3>
    <div class="row" v-if="work">
      <div class="col-12">
        <label>Название</label>
        <input type="text" class="form-control" v-model="work.name" placeholder required />
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <label>Интервал обслуживания</label>
        <input type="text" class="form-control" v-model="work.interval" placeholder />
      </div>
    </div>
    <hr class="mb-4" />
    <button class="btn btn-primary" @click="updateRecord">Сохранить</button>
    <router-link to="/service-works" class="btn btn-primary">Назад</router-link>
  </div>
</template>
<script>
import serviceWorksApi from '@/api/service-works'
import Swal from 'sweetalert2'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'UpdateServiceWork',
  props: ['id'],
  computed: {
    ...mapState('taxi/serviceWorks', {
      workState (state) {
        return state.items.find(e => e.id == this.id)
      },
      isLoading: state => state.isLoading
    }),
    work: {
      get () {
        if (!this.serviceWork) {
          return JSON.parse(JSON.stringify(this.workState ? this.workState : null))
        }
        return this.serviceWork
      },
      set (value) {
        this.serviceWork = value
      }
    }
  },
  mounted () {
    this.loadItem({ id: this.id })
  },
  data () {
    return {
      isUpdating: false,
      serviceWork: null
    }
  },
  methods: {
    updateRecord () {
      if (this.isUpdating) {
        return
      }
      this.isUpdating = true
      serviceWorksApi.updateItem(this.work)
        .then(work => {
          this.isUpdating = false
          this.$router.push('/service-works')
        })
        .catch(text => {
          this.isUpdating = false
          Swal.fire({
            icon: 'error',
            title: 'Ошибка',
            html: text.message
          })
        })
    },
    ...mapActions('taxi/serviceWorks', ['loadItem'])
  }
}
</script>
<style lang="scss" scoped>
  .btn, .btn-primary {
    float: right;
    margin-left: 0.7rem;
  }
</style>
